import React, { PureComponent } from 'react';
import Box from '@rexlabs/box';
import { styled, StyleSheet } from '@rexlabs/styling';
import { Grid, Column } from '@rexlabs/grid';
import { Small } from '../text';
import { Check as Checkbox } from 'view/components/checkbox';
import { HorizontalActionMenu } from 'view/components/action-menu';
import { FONT } from 'src/theme';
import { push } from '@rexlabs/whereabouts';
import ROUTES from 'src/routes';
import { Modal } from 'view/components/modal';
import EditProjectForm from 'view/forms/project-new';
import _ from 'lodash';

import ActionModal from '../../modals/action';

const defaultStyles = StyleSheet({
  text: {
    fontWeight: '500'
  },
  truncate: {
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  status: {
    fontWeight: '500',
    textTransform: 'capitalize'
  },
  container: {
    fontWeight: FONT.WEIGHTS.BOLD
  },
  grid: {
    '> *': {
      padding: '2rem'
    }
  },
  checkbox: {
    cursor: 'default'
  }
});

@styled(defaultStyles)
class ProjectTrashedListItem extends PureComponent {
  state = {
    selected: false,
    archiveModal: false,
    recoverModal: false
  };

  formatDate = (createdAt) => {
    const date = new Date(createdAt * 1000);
    return `${date.getDate()} ${date.toLocaleString('en-us', {
      month: 'long'
    })} ${date.getFullYear()}`;
  };

  recover = () => {
    const { projects, project } = this.props;
    projects
      .archive({
        id: project.id
      })
      .then(() => {
        this.setState({
          recoverModal: false
        });
        projects.refreshList();
      })
      .catch((e) => {
        console.error(e);
        projects.refreshList();
      });
  };

  view = (project) => {
    push(ROUTES.APP.PROJECT, {
      params: {
        projectId: project.id
      }
    });
  };

  render() {
    const { styles: s, project, toggle, checked } = this.props;
    return (
      <Box {...s('container')}>
        {this.state.editModal && (
          <Modal>
            <EditProjectForm
              title="Edit Project"
              closeModal={() => this.setState({ editModal: false })}
              project={project}
            />
          </Modal>
        )}
        {this.state.recoverModal && (
          <ActionModal
            green
            onClose={() => this.setState({ recoverModal: false })}
            onSubmit={this.recover}
            title={'Recover Project Listing(s)?'}
            submitText="Recover"
          >
            Are you sure you want to trash this Project Listing(s) and all
            associated worksheets?
          </ActionModal>
        )}

        <Grid
          gutter={12}
          columns={24}
          style={{ alignItems: 'center' }}
          onClick={() => this.view(project)}
          {...s('grid')}
        >
          <Column
            width={1}
            onClick={(e) => {
              e.stopPropagation();
              toggle();
            }}
            {...s('checkbox')}
          >
            <Checkbox controlled={true} value={!!checked} />
          </Column>
          <Column width={4}>
            <Small {...s('text', 'truncate')}>{project.title}</Small>
          </Column>
          <Column width={4}>
            <Small {...s('text')}>{this.formatDate(project.created_at)}</Small>
          </Column>
          <Column width={4}>
            <Small {...s('status')}>
              {project.status.split('_').join(' ')}
            </Small>
          </Column>
          <Column width={6}>
            <Small {...s('text')}>{_.get(project, 'summary')}</Small>
          </Column>
          <Column width={4}>
            <Small {...s('text')}>{this.formatDate(project.trashed_at)}</Small>
          </Column>
          <Column width={1} onClick={(e) => e.stopPropagation()}>
            <HorizontalActionMenu
              items={[
                {
                  label: 'View',
                  onClick: () => this.view(project)
                },
                {
                  label: 'Edit',
                  onClick: () => this.setState({ editModal: true })
                },
                {
                  label: 'Recover',
                  onClick: () => this.setState({ recoverModal: true })
                }
              ]}
            />
          </Column>
        </Grid>
      </Box>
    );
  }
}

export default ProjectTrashedListItem;
